module.exports = __webpack_public_path__ + "img/mexico_noroeste.fbbda54c.png";